
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import App from './App.vue'
import { createPinia } from 'pinia'
import router from './router'

const app = createApp(App)
const pinia = createPinia()

// 只通过插件注册 ElementPlus（删除手动注册代码）
app.use(ElementPlus)
app.use(router)
app.use(pinia)

app.mount('#app')